// import React, { useState, useEffect, useRef } from "react";
// import "./Main.scss";
// import { Link, Outlet } from "react-router-dom";
// import ShortCutLogo from "../../assets/image/logo/shortcut-logo.svg";
// import LogoSideBar from "../../assets/image/logo/Fathom-logo-sidebar.svg";
// import { SideBarMenu } from "../../assets/data/SideBarMenu";
// import ArrowMenu from "../../assets/image/menubar/arrow-menu.svg";
// import Logout from "../authentification_page/logout/Logout";
// import { useLocation } from "react-router-dom";

// const Main = () => {
//   const [expanding, setExpanding] = useState(false);
//   const [openMenu, setOpenMenu] = useState(null);
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const menuRef = useRef(null);
//   const location = useLocation();

//   const handleExpanding = () => {
//     setExpanding(!expanding);
//   };

//   const handleClickOpen = (index) => {
//     setOpenMenu((prevIndex) => (prevIndex === index ? null : index));
//     if (openMenu) {
//       setSelectedCategory(null);
//     }
//   };

//   const handleClickClose = () => {
//     // setExpanding(!expanding);
//   };

//   const handleClickCategories = (catIndex) => {
//     setSelectedCategory((prevIndex) =>
//       prevIndex === catIndex ? null : catIndex
//     );
//   };

//   const isActiveMenuItem = (currentPath, itemLink) => {
//     return currentPath === itemLink || currentPath.startsWith(itemLink + "/");
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setExpanding(false);
//       }
//     };

//     document.addEventListener("click", handleClickOutside);
//     return () => {
//       document.removeEventListener("click", handleClickOutside);
//     };
//   }, []);

//   return (
//     <div className="frame-main-dasboard">
//       <div
//         className={`frame-left-menu ${expanding ? "expanded" : ""}`}
//         onClick={handleExpanding}
//         ref={menuRef}
//       >
//         <div className="frame-logo-sidebar">
//           <img
//             src={expanding ? LogoSideBar : ShortCutLogo}
//             alt="logo-sidebar"
//             className={`${expanding ? "side-bar-logo" : "shortcut-logo"}`}
//           />
//         </div>

//         <div className="frame_menu_sidebar">
//           {expanding ? (
//             <div className="frame-menu-sidebar-expanding">
//               {SideBarMenu.map((item, index) => (
//                 <div
//                   key={index}
//                   className={`frame-item-menu-expanding ${
//                     openMenu === index && item.categories ? "remove-gap" : ""
//                   }`}
//                   onClick={(e) => e.stopPropagation()}
//                 >
//                   <Link
//                     to={item.link}
//                     onClick={() => handleClickOpen(index)}
//                     className={`frame-icon-title-menu ${
//                       location.pathname.includes(item.link) ||
//                       location.pathname.includes(item.path)
//                         ? "active-selected"
//                         : ""
//                     }`}
//                   >
//                     <div className="frame-icon-menu">
//                       <img src={item.image} alt={item.name} />
//                     </div>

//                     <p>{item.name}</p>
//                     <div className="frame-arrow-menu">
//                       {" "}
//                       {item.categories ? (
//                         <img
//                           src={ArrowMenu}
//                           alt="arrow"
//                           className={`${
//                             openMenu === index && item.categories
//                               ? "rotate-arrow"
//                               : ""
//                           }`}
//                         />
//                       ) : (
//                         ""
//                       )}
//                     </div>
//                   </Link>

//                   {openMenu === index && item.categories && (
//                     <div className="frame-categories-menu">
//                       {item.categories.map((category, catIndex) => (
//                         <div key={catIndex} className="frame-item-categories">
//                           <Link
//                             to={category.link}
//                             onClick={() => handleClickCategories(catIndex)}
//                             className={`frame-categories ${
//                               location.pathname.includes(category.link) ||
//                               location.pathname.includes(category.path)
//                                 ? "active-selected"
//                                 : ""
//                             }`}
//                           >
//                             <p>{category.name}</p>
//                             <div className="frame-arrow-menu">
//                               {" "}
//                               {category.plan ? (
//                                 <img
//                                   src={ArrowMenu}
//                                   alt="arrow"
//                                   className={`${
//                                     selectedCategory === catIndex
//                                       ? "rotate-arrow"
//                                       : ""
//                                   }`}
//                                 />
//                               ) : (
//                                 ""
//                               )}
//                             </div>
//                           </Link>

//                           {selectedCategory === catIndex && category.plan && (
//                             <div className="frame-plan">
//                               {category.plan.map((plan, planIndex) => (
//                                 <Link
//                                   to={plan.link}
//                                   key={planIndex}
//                                   className={`frame-item-plan ${
//                                     location.pathname.includes(plan.link)
//                                       ? "active-selected"
//                                       : ""
//                                   }`}
//                                   onClick={handleClickClose}
//                                 >
//                                   <p>{plan.name}</p>
//                                 </Link>
//                               ))}
//                             </div>
//                           )}
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="frame-menubar-shortcut">
//               {SideBarMenu.map((item, index) => (
//                 <div
//                   key={index}
//                   className={`frame-item-menu-shortcut ${
//                     location.pathname.includes(item.link) ||
//                     isActiveMenuItem(location.pathname, item.link) ||
//                     location.pathname.includes(item.path)
//                       ? "active-selected"
//                       : ""
//                   }`}
//                 >
//                   <img
//                     src={item.image}
//                     alt={item.name}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       handleExpanding();
//                     }}
//                     style={{ cursor: "pointer" }}
//                   />
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         <div className="frame_logout">
//           <Logout />
//         </div>
//       </div>

//       {expanding && (
//         <div className="dark-overlay" onClick={() => setExpanding(false)}></div>
//       )}
//       <div className="frame-right-outlet">
//         <Outlet />
//       </div>
//     </div>
//   );
// };

// export default Main;

import React, { useState, useEffect, useRef } from "react";
import "./Main.scss";
import { Link, Outlet } from "react-router-dom";
import ShortCutLogo from "../../assets/image/logo/shortcut-logo.svg";
import LogoSideBar from "../../assets/image/logo/Fathom-logo-sidebar.svg";
import { SideBarMenu } from "../../assets/data/SideBarMenu";
import ArrowMenu from "../../assets/image/menubar/arrow-menu.svg";
import Logout from "../authentification_page/logout/Logout";
import { useLocation } from "react-router-dom";

const Main = () => {
  const [expanding, setExpanding] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const menuRef = useRef(null);
  const location = useLocation();

  const handleExpanding = () => {
    setExpanding(!expanding);
  };

  const handleClickOpen = (index) => {
    // Toggle the openMenu state without clearing it on data updates
    setOpenMenu((prevIndex) => (prevIndex === index ? null : index));
  };

  const handleClickCategories = (catIndex) => {
    setSelectedCategory((prevIndex) =>
      prevIndex === catIndex ? null : catIndex
    );
  };

  const isActiveMenuItem = (currentPath, itemLink) => {
    return currentPath === itemLink || currentPath.startsWith(itemLink + "/");
  };

  // Use useEffect to initialize openMenu based on the current route
  useEffect(() => {
    // Find the index of the menu item that matches the current route
    const matchingMenuIndex = SideBarMenu.findIndex(
      (item) =>
        location.pathname.includes(item.link) ||
        location.pathname.includes(item.path)
    );

    if (matchingMenuIndex !== -1) {
      setOpenMenu(matchingMenuIndex);

      // If we have categories, also set the selected category
      const menuItem = SideBarMenu[matchingMenuIndex];
      if (menuItem.categories) {
        const matchingCategoryIndex = menuItem.categories.findIndex(
          (category) =>
            location.pathname.includes(category.link) ||
            location.pathname.includes(category.path)
        );

        if (matchingCategoryIndex !== -1) {
          setSelectedCategory(matchingCategoryIndex);
        }
      }
    }
  }, [location.pathname]); // Only run when the route changes

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setExpanding(false);
        // Don't reset openMenu here so it stays preserved
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className="frame-main-dasboard">
      <div
        className={`frame-left-menu ${expanding ? "expanded" : ""}`}
        onClick={handleExpanding}
        ref={menuRef}
      >
        <div className="frame-logo-sidebar">
          <img
            src={expanding ? LogoSideBar : ShortCutLogo}
            alt="logo-sidebar"
            className={`${expanding ? "side-bar-logo" : "shortcut-logo"}`}
          />
        </div>

        <div className="frame_menu_sidebar">
          {expanding ? (
            <div className="frame-menu-sidebar-expanding">
              {SideBarMenu.map((item, index) => (
                <div
                  key={index}
                  className={`frame-item-menu-expanding ${
                    openMenu === index && item.categories ? "remove-gap" : ""
                  }`}
                  onClick={(e) => e.stopPropagation()}
                >
                  <Link
                    to={item.link}
                    onClick={() => handleClickOpen(index)}
                    className={`frame-icon-title-menu ${
                      location.pathname.includes(item.link) ||
                      location.pathname.includes(item.path)
                        ? "active-selected"
                        : ""
                    }`}
                  >
                    <div className="frame-icon-menu">
                      <img src={item.image} alt={item.name} />
                    </div>

                    <p>{item.name}</p>
                    <div className="frame-arrow-menu">
                      {" "}
                      {item.categories ? (
                        <img
                          src={ArrowMenu}
                          alt="arrow"
                          className={`${
                            openMenu === index && item.categories
                              ? "rotate-arrow"
                              : ""
                          }`}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Link>

                  {openMenu === index && item.categories && (
                    <div className="frame-categories-menu">
                      {item.categories.map((category, catIndex) => (
                        <div key={catIndex} className="frame-item-categories">
                          <Link
                            to={category.link}
                            onClick={() => handleClickCategories(catIndex)}
                            className={`frame-categories ${
                              location.pathname.includes(category.link) ||
                              location.pathname.includes(category.path)
                                ? "active-selected"
                                : ""
                            }`}
                          >
                            <p>{category.name}</p>
                            <div className="frame-arrow-menu">
                              {" "}
                              {category.plan ? (
                                <img
                                  src={ArrowMenu}
                                  alt="arrow"
                                  className={`${
                                    selectedCategory === catIndex
                                      ? "rotate-arrow"
                                      : ""
                                  }`}
                                />
                              ) : (
                                ""
                              )}
                            </div>
                          </Link>

                          {selectedCategory === catIndex && category.plan && (
                            <div className="frame-plan">
                              {category.plan.map((plan, planIndex) => (
                                <Link
                                  to={plan.link}
                                  key={planIndex}
                                  className={`frame-item-plan ${
                                    location.pathname.includes(plan.link)
                                      ? "active-selected"
                                      : ""
                                  }`}
                                >
                                  <p>{plan.name}</p>
                                </Link>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="frame-menubar-shortcut">
              {SideBarMenu.map((item, index) => (
                <div
                  key={index}
                  className={`frame-item-menu-shortcut ${
                    location.pathname.includes(item.link) ||
                    isActiveMenuItem(location.pathname, item.link) ||
                    location.pathname.includes(item.path)
                      ? "active-selected"
                      : ""
                  }`}
                >
                  <img
                    src={item.image}
                    alt={item.name}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleExpanding();
                    }}
                    style={{ cursor: "pointer" }}
                  />
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="frame_logout">
          <Logout />
        </div>
      </div>

      {expanding && (
        <div className="dark-overlay" onClick={() => setExpanding(false)}></div>
      )}
      <div className="frame-right-outlet">
        <Outlet />
      </div>
    </div>
  );
};

export default Main;

// import React, { useState, useEffect, useRef } from "react";
// import "./Main.scss";
// import { Link, Outlet, useNavigate } from "react-router-dom";
// import ShortCutLogo from "../../assets/image/logo/shortcut-logo.svg";
// import LogoSideBar from "../../assets/image/logo/Fathom-logo-sidebar.svg";
// import { SideBarMenu } from "../../assets/data/SideBarMenu";
// import ArrowMenu from "../../assets/image/menubar/arrow-menu.svg";
// import Logout from "../authentification_page/logout/Logout";
// import { useLocation } from "react-router-dom";

// const Main = () => {
//   const [expanding, setExpanding] = useState(false);
//   const [openMenu, setOpenMenu] = useState(null);
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const menuRef = useRef(null);
//   const location = useLocation();
//   const navigate = useNavigate();

//   const handleExpanding = () => {
//     setExpanding(!expanding);
//   };

//   const handleClickOpen = (index) => {
//     // Toggle the openMenu state without clearing it on data updates
//     setOpenMenu((prevIndex) => (prevIndex === index ? null : index));
//   };

//   const handleClickCategories = (catIndex) => {
//     setSelectedCategory((prevIndex) =>
//       prevIndex === catIndex ? null : catIndex
//     );
//   };

//   const isActiveMenuItem = (currentPath, itemLink) => {
//     return currentPath === itemLink || currentPath.startsWith(itemLink + "/");
//   };

//   // Handle click on shortcut menu items
//   const handleShortcutClick = (e, item) => {
//     e.stopPropagation();
//     navigate(item.shortcutLink);
//     setExpandingAfterDelay();
//   };

//   // Set expanding after a short delay to ensure navigation happens first
//   const setExpandingAfterDelay = () => {
//     setTimeout(() => {
//       setExpanding(true);
//     }, 100);
//   };

//   // Use useEffect to initialize openMenu based on the current route
//   useEffect(() => {
//     // Find the index of the menu item that matches the current route
//     const matchingMenuIndex = SideBarMenu.findIndex(
//       (item) =>
//         location.pathname.includes(item.link) ||
//         location.pathname.includes(item.path)
//     );

//     if (matchingMenuIndex !== -1) {
//       setOpenMenu(matchingMenuIndex);

//       // If we have categories, also set the selected category
//       const menuItem = SideBarMenu[matchingMenuIndex];
//       if (menuItem.categories) {
//         const matchingCategoryIndex = menuItem.categories.findIndex(
//           (category) =>
//             location.pathname.includes(category.link) ||
//             location.pathname.includes(category.path)
//         );

//         if (matchingCategoryIndex !== -1) {
//           setSelectedCategory(matchingCategoryIndex);
//         }
//       }
//     }
//   }, [location.pathname]); // Only run when the route changes

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setExpanding(false);
//         // Don't reset openMenu here so it stays preserved
//       }
//     };

//     document.addEventListener("click", handleClickOutside);
//     return () => {
//       document.removeEventListener("click", handleClickOutside);
//     };
//   }, []);

//   return (
//     <div className="frame-main-dasboard">
//       <div
//         className={`frame-left-menu ${expanding ? "expanded" : ""}`}
//         onClick={handleExpanding}
//         ref={menuRef}
//       >
//         <div className="frame-logo-sidebar">
//           <img
//             src={expanding ? LogoSideBar : ShortCutLogo}
//             alt="logo-sidebar"
//             className={`${expanding ? "side-bar-logo" : "shortcut-logo"}`}
//           />
//         </div>

//         <div className="frame_menu_sidebar">
//           {expanding ? (
//             <div className="frame-menu-sidebar-expanding">
//               {SideBarMenu.map((item, index) => (
//                 <div
//                   key={index}
//                   className={`frame-item-menu-expanding ${
//                     openMenu === index && item.categories ? "remove-gap" : ""
//                   }`}
//                   onClick={(e) => e.stopPropagation()}
//                 >
//                   <Link
//                     to={item.link}
//                     onClick={() => handleClickOpen(index)}
//                     className={`frame-icon-title-menu ${
//                       location.pathname.includes(item.link) ||
//                       location.pathname.includes(item.path)
//                         ? "active-selected"
//                         : ""
//                     }`}
//                   >
//                     <div className="frame-icon-menu">
//                       <img src={item.image} alt={item.name} />
//                     </div>

//                     <p>{item.name}</p>
//                     <div className="frame-arrow-menu">
//                       {" "}
//                       {item.categories ? (
//                         <img
//                           src={ArrowMenu}
//                           alt="arrow"
//                           className={`${
//                             openMenu === index && item.categories
//                               ? "rotate-arrow"
//                               : ""
//                           }`}
//                         />
//                       ) : (
//                         ""
//                       )}
//                     </div>
//                   </Link>

//                   {openMenu === index && item.categories && (
//                     <div className="frame-categories-menu">
//                       {item.categories.map((category, catIndex) => (
//                         <div key={catIndex} className="frame-item-categories">
//                           <Link
//                             to={category.link}
//                             onClick={() => handleClickCategories(catIndex)}
//                             className={`frame-categories ${
//                               location.pathname.includes(category.link) ||
//                               location.pathname.includes(category.path)
//                                 ? "active-selected"
//                                 : ""
//                             }`}
//                           >
//                             <p>{category.name}</p>
//                             <div className="frame-arrow-menu">
//                               {" "}
//                               {category.plan ? (
//                                 <img
//                                   src={ArrowMenu}
//                                   alt="arrow"
//                                   className={`${
//                                     selectedCategory === catIndex
//                                       ? "rotate-arrow"
//                                       : ""
//                                   }`}
//                                 />
//                               ) : (
//                                 ""
//                               )}
//                             </div>
//                           </Link>

//                           {selectedCategory === catIndex && category.plan && (
//                             <div className="frame-plan">
//                               {category.plan.map((plan, planIndex) => (
//                                 <Link
//                                   to={plan.link}
//                                   key={planIndex}
//                                   className={`frame-item-plan ${
//                                     location.pathname.includes(plan.link)
//                                       ? "active-selected"
//                                       : ""
//                                   }`}
//                                 >
//                                   <p>{plan.name}</p>
//                                 </Link>
//                               ))}
//                             </div>
//                           )}
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="frame-menubar-shortcut">
//               {SideBarMenu.map((item, index) => (
//                 <div
//                   key={index}
//                   className={`frame-item-menu-shortcut ${
//                     location.pathname.includes(item.link) ||
//                     isActiveMenuItem(location.pathname, item.link) ||
//                     location.pathname.includes(item.path)
//                       ? "active-selected"
//                       : ""
//                   }`}
//                 >
//                   <img
//                     src={item.image}
//                     alt={item.name}
//                     onClick={(e) => handleShortcutClick(e, item)}
//                     style={{ cursor: "pointer" }}
//                   />
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         <div className="frame_logout">
//           <Logout />
//         </div>
//       </div>

//       {expanding && (
//         <div className="dark-overlay" onClick={() => setExpanding(false)}></div>
//       )}
//       <div className="frame-right-outlet">
//         <Outlet />
//       </div>
//     </div>
//   );
// };

// export default Main;
